/**
 * Returns an answer array for question type `small_image_select` , 
 *  `large_image_select` and 'box_select'
 *
 * @export
 * @param {*} answers
 * @param {*} question
 * @returns
 */
export default function(answers, question) {
    return Object.keys(question.select).map((option, index) => ({
        key: String(index),
        name: question.select[option],
        user: answers.filter((answer) => answer.value.find((kv) => kv.key == index))
    }))
}
